import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import avtar1 from '../assets/images/user/avatar-1.jpg'
import { getData } from './Services/api'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
} from 'chart.js';

import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
);

const Home = () => {
    const [home, setHome] = useState({})
    const [recentOrders, setRecentOrders] = useState([])
    const [revenueChart, setRevenueChart] = useState([]);

    const fetchHomeData = async () => {
        try {
            const res = await getData('/dashboard');
            if (res.status) {
                setHome(res.data.cards || {});
                setRecentOrders(res.data.recentOrders || []);
                setRevenueChart(res.data.revenueChart || []);
            }
        } catch (error) {
            console.log("fetch home data", error)
        }
    }
    const revenueData = {
        labels: revenueChart.map(item => item._id),
        datasets: [
            {
                label: 'Revenue',
                data: revenueChart.map(item => item.revenue),
                backgroundColor: '#0d6efd'
            }
        ]
    };

    const revenueOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            y: {
                beginAtZero: true
            }
        }
    };

    useEffect(() => {
        fetchHomeData();
    }, [])
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Home
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Home</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h3 className="mb-1"> {home?.totalOrders}</h3>
                                            <p className="text-muted mb-0">Total Orders</p>
                                        </div>
                                        <div className="col-4 text-end">
                                            <i className="fas fa-shopping-cart text-secondary f-36" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h3 className="mb-1">₹{home?.totalRevenue}</h3>
                                            <p className="text-muted mb-0">Total Revenue</p>
                                        </div>
                                        <div className="col-4 text-end">
                                            <i className="fas fa-dollar-sign text-success f-36" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h3 className="mb-1">{home?.totalUsers}</h3>
                                            <p className="text-muted mb-0">Total Users</p>
                                        </div>
                                        <div className="col-4 text-end">
                                            <i className="fas fa-users text-primary f-36" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-8">
                                            <h3 className="mb-1">{home?.totalProducts}</h3>
                                            <p className="text-muted mb-0">Total Products</p>
                                        </div>
                                        <div className="col-4 text-end">
                                            <i className="fas fa-box text-info f-36" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="card new-cust-card">
                                <div className="card-header">
                                    <h5>Recent Orders</h5>
                                </div>
                                <div
                                    className="customer-scroll"
                                >
                                    <div className="card-body p-b-0">
                                        {recentOrders?.length > 0 ? (
                                            recentOrders.map((order) => (
                                                <div key={order._id} className="d-flex align-items-center mb-3">
                                                    <div className="flex-shrink-0">
                                                        <img
                                                            src={avtar1}
                                                            alt="user"
                                                            className="rounded-circle"
                                                            width="45"
                                                        />
                                                    </div>

                                                    <div className="flex-grow-1 ms-3">
                                                        <h6 className="mb-0">{order.orderId}</h6>
                                                        <small className="text-muted">
                                                            {order.user?.email}
                                                        </small>
                                                    </div>

                                                    <div className="text-end">
                                                        <h6 className="mb-0">₹{order.totalAmount}</h6>
                                                        <span className={`badge ${order.orderStatus === 'PLACED' ? 'bg-secondary' :
                                                            order.orderStatus === 'CONFIRMED' ? 'bg-primary' :
                                                                order.orderStatus === 'SHIPPED' ? 'bg-warning text-dark' :
                                                                    order.orderStatus === 'DELIVERED' ? 'bg-success' :
                                                                        'bg-danger'
                                                            }`}>
                                                            {order.orderStatus}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-center text-muted">No Recent Orders</div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Revenue (Last 7 Days)</h5>
                                </div>
                                <div className="card-body" style={{ height: '300px' }}>
                                    {revenueChart.length > 0 ? (
                                        <Bar data={revenueData} options={revenueOptions} />
                                    ) : (
                                        <div className="text-center text-muted mt-5">
                                            No revenue data available
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Home